export default "__VITE_ASSET__BwL8Ml_a__"